import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope, faMobile, faTh, faThLarge,
} from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import { findUsersUsingAgentIds } from '@functions/agent'

import useCampaign from '@hooks/useCampaign'
import useFlipperKey from '@hooks/useFlipperKey'
import useSelector from '@hooks/useSelector'

import type { CampaignModel } from '@models/types'

interface MediaSelectionToolsProps {
  campaign: CampaignModel,
  isMediaSelector: boolean,
  setViewMode: (viewMode: 'small' | 'large') => void,
  viewMode: 'small' | 'large',
}

const MediaSelectionTools = (props: MediaSelectionToolsProps) => {
  const { campaign, isMediaSelector, setViewMode, viewMode } = props
  const { isEnabled: photosPlansV2 } = useFlipperKey('photos_plans_v2')

  const campaignPayload = useCampaign(campaign)
  const {
    callbacks: {
      selectSMSRecipient,
      shareEmailLink,
    },
    campaign: {
      agent_ids: agentIds,
    },
  } = campaignPayload

  const { users } = useSelector(reduxState => reduxState.entities)

  const campaignAgentUsers = findUsersUsingAgentIds({ agentIds, users })
  const agentUsersWithMobileNumber = campaignAgentUsers.filter(user => !!user?.mobile_number)
  const agentUsersWithEmail = campaignAgentUsers.filter(user => !!user?.email)

  const toggleViewModeButton = (
    <Button
      buttonStyle="secondaryUtility"
      icon={<FontAwesomeIcon icon={viewMode === 'large' ? faTh : faThLarge} />}
      marginTop="medium"
      onClick={() => setViewMode(viewMode === 'large' ? 'small' : 'large')}
      size="medium"
    >
      {viewMode === 'large' ? 'Small Thumbnail View' : 'Large Thumbnail View'}
    </Button>
  )

  return (
    <Tools>
      {!isMediaSelector && (
        <>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faMobile} />}
            onClick={() => selectSMSRecipient({
              activityKey: 'media_selection.shared',
              endPoint: `campaigns/${campaign.id}/users`,
              linkAnchor: 'media-selection?mediaSelector=true',
              preSelectedUsers: agentUsersWithMobileNumber,
              completeSelection: false,
            })}
            size="medium"
          >
            Send for Selection (SMS)
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faEnvelope} />}
            marginTop="medium"
            onClick={() => shareEmailLink({
              endPoint: `campaigns/${campaign.id}/users`,
              linkAnchor: 'media-selection?mediaSelector=true',
              preSelectedUsers: agentUsersWithEmail,
              completeSelection: false,
            })}
            size="medium"
          >
            Send for Selection (Email)
          </Button>

          {photosPlansV2 && toggleViewModeButton}
        </>
      )}

      {isMediaSelector && (
        <>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faEnvelope} />}
            onClick={() => shareEmailLink({
              endPoint: `campaigns/${campaign.id}/users`,
              linkAnchor: 'media-selection',
              preSelectedUsers: [],
              completeSelection: true,
            })}
            size="medium"
          >
            Complete Media Selection
          </Button>

          {photosPlansV2 && toggleViewModeButton}
        </>
      )}
    </Tools>
  )
}

export default MediaSelectionTools
